module.exports = __webpack_public_path__ + "static/media/loader.e12d0184.svg";